import router from "@/router";
import axios, { AxiosRequestConfig, AxiosResponse, AxiosPromise } from "axios";
import { ElMessage } from "element-plus";
import { getApiBaseUrl } from "@/utils/apiBase";
import {
  clearPortalSession,
  getRequestAuth,
  PORTAL_TENANT,
  PORTAL_PLATFORM,
} from "@/utils/authSession";
import { normalizeResponseDates } from "@/utils/dateTime";

const instance = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 5000,
});

instance.interceptors.request.use(
  function (config) {

    config.headers['Content-Type'] = 'application/json'

    const auth = getRequestAuth()
    const token = auth?.token
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    const tenantId = auth?.tenantId
    if (tenantId) {
      config.headers["X-Tenant-Id"] = tenantId
    }

    // 在请求发送之前做一些处理
    // config.cancelToken = new axios.CancelToken((cancel) => {});
    return config;
  },

  function (error) {
    // 对请求错误做些什么
    // ...
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    if (response.data && typeof response.data === 'object') {
      if (response.data.data !== undefined) {
        response.data.data = normalizeResponseDates(response.data.data);
      } else {
        response.data = normalizeResponseDates(response.data);
      }
    }
    if (response.data.code === 401 || response.data.code === '401') {
      ElMessage({
        type: "error",
        message: "登录失效！ 请重新登录",
      });
      const portal = getRequestAuth()?.portal === PORTAL_PLATFORM ? PORTAL_PLATFORM : PORTAL_TENANT
      clearPortalSession(portal)
      router.push(portal === PORTAL_PLATFORM ? "/superadmin/login" : "/login");
      return response.data;
    }
    if (response.data.code === 200) {
      return response.data;
    } else {
      return response.data;
    }
  },

  function (error) {
    if (error.message.indexOf("timeout") != -1) {
      ElMessage.error("网络超时");
    } else if (error.message == "Network Error") {
      ElMessage.error("网络连接错误");
    } else if (error.response) {
      const status = error.response.status;
      if (status === 401) {
        ElMessage.error("登录失效！请重新登录");
        const portal = getRequestAuth()?.portal === PORTAL_PLATFORM ? PORTAL_PLATFORM : PORTAL_TENANT;
        clearPortalSession(portal);
        router.push(portal === PORTAL_PLATFORM ? "/superadmin/login" : "/login");
      } else if (status === 403) {
        const msg = error.response.data?.msg || "无权限访问该功能";
        ElMessage.warning(msg);
      } else {
        ElMessage.error(error.response.statusText || "请求失败");
      }
    } else {
      ElMessage.error("接口路径找不到");
    }
    return Promise.reject(error);
  }
);

export default instance;